export default __webpack_public_path__ + "static/FNL-WI-1-4537257e73237b0e7fd8abc15b0f04db.jpg";